import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import landingComp from "../components/home/landingComp";
import specialsComp from "../components/home/specialsComp";
import orderSteps from "../components/home/orderSteps";
import appSlider from "../components/home/appSlider";
import statsView from "../components/home/statsView";
import pageFooter from "../components/pageFooter";
import loginView from "../views/loginView";
import forgetPassword from "../views/forgetPassword";
import keyCode from "../views/keyCode";
import changePassword from "../views/changePassword";
import registerView from "../views/registerView";
import PackagesView from "../views/PackagesView";
import contactView from "../views/contactView";
import dashboardHome from "../views/dashboardHome";
import addBuilding from "../views/addBuilding";
import completeBuilding from "../views/completeBuilding";
import moreAboutSaqf from "../views/moreAboutSaqf";
import managementOrders from "../views/managementOrders";
import buildingsView from "../views/buildingsView";
import orderDetails from "../views/orderDetails";
import buildingDetails from "../views/buildingDetails";
import tenantsView from "../views/tenantsView";
import manageGeneral from "../views/manageGeneral";
import addTenant from "../views/addTenant";
import tenantDetails from "../views/tenantDetails";
import editTenant from "../views/editTenant";
import editBuilding from "../views/editBuilding";
import reviewsView from "../views/reviewsView";
import ownersView from "../views/ownersView";
import ownerDetails from "../views/ownerDetails";
import sendNotifications from "../views/sendNotifications";
import addOwner from "../views/addOwner";
import editOwner from "../views/editOwner";
import MaintenanceDetails from "../views/MaintenanceDetails";
import MaintenanceView from "../views/MaintenanceView";
import TechniciansView from "../views/TechniciansView";
import addTechnicain from "../views/addTechnicain";
import editTechnicain from "../views/editTechnicain";
import packagesDashboard from "../views/packagesDashboard";
import walletView from "../views/walletView";
import fainancialView from "../views/fainancialView";
import contactDashboard from "../views/contactDashboard";
import notificationsView from "../views/notificationsView";
import manageMessage from "../views/manageMessage";
import editProfile from "../views/editProfile";
import changePasswordDash from "../views/changePasswordDash";
import forgetPassCheck from "../views/forgetPassCheck";
import changePhone from "../views/changePhone";
import changePhoneSend from "../views/changePhoneSend";
import phoneCheckOtp from "../views/phoneCheckOtp";
import sideBarView from "../components/dashboard/sideBarView";
import navbarView from "../components/dashboard/navbarView";
import HomeBoxes from "../components/dashboard/HomeBoxes";
import clientsReviews from "../components/dashboard/clientsReviews";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/landingComp",
    name: "landingComp",
    component: landingComp,
  },
  {
    path: "/specialsComp",
    name: "specialsComp",
    component: specialsComp,
  },
  {
    path: "/orderSteps",
    name: "orderSteps",
    component: orderSteps,
  },
  {
    path: "/appSlider",
    name: "appSlider",
    component: appSlider,
  },
  {
    path: "/statsView",
    name: "statsView",
    component: statsView,
  },
  {
    path: "/pageFooter",
    name: "pageFooter",
    component: pageFooter,
  },
  {
    path: "/loginView",
    name: "loginView",
    component: loginView,
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: forgetPassword,
  },
  {
    path: "/keyCode",
    name: "keyCode",
    component: keyCode,
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: changePassword,
  },
  {
    path: "/registerView",
    name: "registerView",
    component: registerView,
  },
  {
    path: "/PackagesView",
    name: "PackagesView",
    component: PackagesView,
  },
  {
    path: "/contactView",
    name: "contactView",
    component: contactView,
  },
  {
    path: "/dashboardHome",
    name: "dashboardHome",
    component: dashboardHome,
  },
  {
    path: "/sideBarView",
    name: "sideBarView",
    component: sideBarView,
  },
  {
    path: "/navbarView",
    name: "navbarView",
    component: navbarView,
  },
  {
    path: "/HomeBoxes",
    name: "HomeBoxes",
    component: HomeBoxes,
  },
  {
    path: "/clientsReviews",
    name: "clientsReviews",
    component: clientsReviews,
  },
  {
    path: "/addBuilding/:id",
    name: "addBuilding",
    component: addBuilding,
  },
  {
    path: "/completeBuilding/:id",
    name: "completeBuilding",
    component: completeBuilding,
  },
  {
    path: "/moreAboutSaqf",
    name: "moreAboutSaqf",
    component: moreAboutSaqf,
  },
  {
    path: "/managementOrders",
    name: "managementOrders",
    component: managementOrders,
  },

  {
    path: "/orderDetails/:id",
    name: "orderDetails",
    component: orderDetails,
  },
  {
    path: "/buildingsView",
    name: "buildingsView",
    component: buildingsView,
  },
  {
    path: "/buildingDetails/:id",
    name: "buildingDetails",
    component: buildingDetails,
  },
  {
    path: "/tenantsView/:id",
    name: "tenantsView",
    component: tenantsView,
  },
  {
    path: "/manageGeneral",
    name: "manageGeneral",
    component: manageGeneral,
  },
  {
    path: "/addTenant/:id",
    name: "addTenant",
    component: addTenant,
  },
  {
    path: "/tenantDetails/:id",
    name: "tenantDetails",
    component: tenantDetails,
  },
  {
    path: "/editTenant/:id",
    name: "editTenant",
    component: editTenant,
  },
  {
    path: "/editBuilding/:id",
    name: "editBuilding",
    component: editBuilding,
  },
  {
    path: "/reviewsView",
    name: "reviewsView",
    component: reviewsView,
  },
  {
    path: "/ownersView",
    name: "ownersView",
    component: ownersView,
  },
  {
    path: "/sendNotifications",
    name: "sendNotifications",
    component: sendNotifications,
  },
  {
    path: "/addOwner",
    name: "addOwner",
    component: addOwner,
  },
  {
    path: "/ownerDetails/:id",
    name: "ownerDetails",
    component: ownerDetails,
  },
  {
    path: "/editOwner/:id",
    name: "editOwner",
    component: editOwner,
  },
  {
    path: "/MaintenanceView",
    name: "MaintenanceView",
    component: MaintenanceView,
  },
  {
    path: "/TechniciansView",
    name: "TechniciansView",
    component: TechniciansView,
  },
  {
    path: "/addTechnicain",
    name: "addTechnicain",
    component: addTechnicain,
  },
  {
    path: "/editTechnicain/:id",
    name: "editTechnicain",
    component: editTechnicain,
  },
  {
    path: "/MaintenanceDetails/:id",
    name: "MaintenanceDetails",
    component: MaintenanceDetails,
  },
  {
    path: "/packagesDashboard",
    name: "packagesDashboard",
    component: packagesDashboard,
  },
  {
    path: "/walletView",
    name: "walletView",
    component: walletView,
  },
  {
    path: "/fainancialView",
    name: "fainancialView",
    component: fainancialView,
  },
  {
    path: "/contactDashboard",
    name: "contactDashboard",
    component: contactDashboard,
  },
  {
    path: "/notificationsView",
    name: "notificationsView",
    component: notificationsView,
  },
  {
    path: "/manageMessage",
    name: "manageMessage",
    component: manageMessage,
  },
  {
    path: "/editProfile",
    name: "editProfile",
    component: editProfile,
  },
  {
    path: "/changePasswordDash",
    name: "changePasswordDash",
    component: changePasswordDash,
  },
  {
    path: "/forgetPassCheck",
    name: "forgetPassCheck",
    component: forgetPassCheck,
  },
  {
    path: "/changePhone",
    name: "changePhone",
    component: changePhone,
  },
  {
    path: "/changePhoneSend",
    name: "changePhoneSend",
    component: changePhoneSend,
  },
  {
    path: "/phoneCheckOtp",
    name: "phoneCheckOtp",
    component: phoneCheckOtp,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
    scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    if (to.hash) {
      // أحياناً العنصر بيتأخر في الrender بعد الانتقال للصفحة
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: "smooth",
            top: 80, // لو عندك header ثابت
          });
        }, 500);
      });
    }

    return { top: 0 };
  },
  // scrollBehavior() {
  //   window.scrollTo(0, 0);
  // },
});

export default router;
